import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgCircle from '../../../others/svg_dist/Circle';

type Props = {};

type State = {};

class Banner extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.ContentContainer>
					<Styles.SectionLeft>
						<Styles.CirclesContainer>
							<SvgCircle fill="#F3F68D" />
							<SvgCircle fill="#F3F68D" />
							<SvgCircle fill="#F3F68D" />
						</Styles.CirclesContainer>
						<div>
							<Styles.HeadingFont>najczęściej</Styles.HeadingFont>
							<Styles.HeadingFont>zadawane</Styles.HeadingFont>
							<Styles.HeadingFont>pytania</Styles.HeadingFont>
						</div>
					</Styles.SectionLeft>
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default Banner;
